<template>
  <div class="row series-card">
    <div class="shadow-box col-sm-12">
      <div class="row">
        <div class="col-sm-12 series-card-header">
          <h1>{{ title }} - {{ cure }} Cure</h1>
        </div>
        <div class="col-sm-12 series-card-content">
          <div class="row">
            <a class="col-sm-7 series-card-image series-card-right-radius" :href="url">
              <img class="lrg-series-img" :src="lrgImg" v-if="lrgImg" />
              <img class="med-series-img" :src="medImg" v-if="medImg" />
              <img class="sml-series-img" :src="smlImg" v-if="smlImg" />
              <img class="mbl-series-img" :src="mblImg" v-if="mblImg" />
            </a>
            <div class="col-sm-5 series-card-key-features series-card-right-radius">
              <h2>Key Features</h2>
              <ul>
                <li v-for="feature in keyFeatures">{{ feature }}</li>
              </ul>
              <a :href="url" class="btn btn-orange">Shop {{ title }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'series-card',
    props: {
      title: {
        type: String,
        required: true
      },
      cure: {
        type: String,
        required: true
      },
      keyFeatures: {
        type: Array,
        required: true
      },
      url: {
        type: String,
        required: true
      },
      lrgImg: String,
      medImg: String,
      smlImg: String,
      mblImg: String
    }
  };
</script>